var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal-box',{attrs:{"close-callback":_vm.closeModal,"template-body-instance":_vm.modalBoxBodyInstance()}})
}
var staticRenderFns = []

export { render, staticRenderFns }